import { createStyles, rem } from '@mantine/core'

const textColor = {
  fontSize: 40,
  fontWeight: 750,
  color: '#fff',
  textShadow: 'rgb(43, 191, 255) 0px 0px 0px, 0.5px 1px 2px  #663C1D',
  // '-webkit-text-stroke': '1px #FFB700',
  // box-shadow: 0.5px 1px 2px 0px #663C1D;
}

type StylesParams = {
  isLiveEvent: boolean
  isEndLive: boolean
}

export default createStyles(
  (theme, { isLiveEvent, isEndLive }: StylesParams) => {
    return {
      root: {
        display: 'flex',
        gap: 40,
        alignItems: 'center',
        [theme.fn.smallerThan('sm')]: {
          flexDirection: 'column',
          justifyContent: 'center',
          gap: 16,
        },
      },
      heading: {
        fontSize: 24,
        lineHeight: rem(32),
        fontWeight: 700,
        textAlign: 'center',
        marginBottom: 8,
        color: theme.colors.gray[7],
        [theme.fn.largerThan('sm')]: {
          fontSize: 26,
          lineHeight: rem(36),
        },
      },
      info: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 24,
        [theme.fn.largerThan('sm')]: {
          width: 360,
        },
        [theme.fn.smallerThan('sm')]: {
          width: '100%',
        },
      },
      topInfo: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
      thumbFrame: {
        cursor: 'pointer',
        [theme.fn.smallerThan('sm')]: {
          width: '100%',
        },
        flexGrow: 1,
        '&, img': {
          borderRadius: 8,
        },
      },
      statusBar: {
        display: 'flex',
        alignItems: 'center',
        backgroundImage: isEndLive
          ? 'linear-gradient(139.59deg, #BFC5CC 2.87%, #87909C 89.05%)'
          : isLiveEvent
          ? 'linear-gradient(271.93deg, #E64728 25.89%, #FC8A09 131.8%)'
          : 'linear-gradient(139.59deg, #FFE16B 2.87%, #FFBA0F 58.46%, #FB8908 89.05%)',
        justifyContent: 'center',
        height: 76,
        marginTop: -10,
        borderRadius: 12,
      },
      liveBar: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
      },
      liveText: {
        color: '#fff',
        textTransform: 'uppercase',
        fontSize: 24,
        fontWeight: 700,
        textShadow: 'rgb(43, 191, 255) 0px 0px 0px, 0.5px 1px 2px  #663C1D',
        [theme.fn.largerThan('sm')]: {
          fontSize: 32,
        },
      },
      timer: {
        background: 'transparent',
      },
      timerItem: {
        background: 'transparent',
        width: 50,
        height: 'auto',
      },
      timerText: {
        ...textColor,
      },
      timerDivider: {
        ...textColor,
        padding: '0 5px',
        marginTop: -5,
      },
      timerUnit: {
        textTransform: 'uppercase',
        fontSize: rem(12),
        color: '#fff',
        fontWeight: 700,
      },
      announceText: {
        color: '#fff',
        fontWeight: 800,
        fontSize: 18,
        textTransform: 'uppercase',
      },
      action: {
        display: 'flex',
        justifyContent: 'center',
        [theme.fn.smallerThan('sm')]: {
          display: 'none',
        },
      },
      btn: {
        backgroundColor: '#FB8908 !important' as any,
        height: 48,
        [theme.fn.smallerThan('sm')]: {
          fontSize: 14,
          paddingLeft: 0,
          paddingRight: 0,
          textAlign: 'center',
        },
      },
      sticky: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 3,
        backgroundColor: 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(8px)',
        padding: 16,
        display: 'flex',
        gap: 8,
        '.action-btn': {
          width: '100%',
        },
      },
      share: {
        width: 48,
        flexShrink: 0,
      },
    }
  },
)
